// extracted by mini-css-extract-plugin
export default {"result-layout":"styles_result-layout__7JMMu","result-preview":"styles_result-preview__Xu0Ax","markdown-skill-parser":"styles_markdown-skill-parser__VUJHM"};